<main>
  <div id="botao-chama-chat" style="position: fixed; right: 20px; bottom: 20px;" (click)="openChatWhatsapp()">
      <img height="90px" style="border-radius: 50px;" alt="Ícone do chatbot" src="/assets/images/avatar-nisia.png" />
  </div>
  <div id="botao-chama-chat-dialogo" style="position: fixed; right: 88px; bottom: 88px;" (click)="openChatWhatsapp()">
    <span>Fale com Nísia!</span>
  </div>
  <section [ngClass]="chat">
      <div class="chat-header">
          <div class="row" style="display: flex; justify-content: space-between;
                align-items: center; padding-left: 15px; padding-right: 15px;">
              <div>
                  <h2 style="padding-left: 10px">Assistente Virtual Nísia</h2>
              </div>
              <div>
                  <img id="botao-fecha-chat" alt="Ícone do fechar chatbot"
                       src="/assets/images/x_circulo.svg" (click)="closeChat()"/>
              </div>
          </div>

      </div>
    <article class="areaChat">
          <div #scrollMe class="box-chat" id="boxChat">
              <div class="row row-dialogo">
              </div>
              <div #dialogoChat id="dialogo">
                <div class="loading-overlay" *ngIf="isLoading">
                    <div class="loading-spinner"></div>
                  </div>
              </div>
          </div>
          <div class="footer-chat">
              <input #inputChat autocomplete="off" placeholder="Digite sua mensagem..." id="inputMsg"
                  (keyup.enter)="enviarMgsUsuarioParaRobo(null, null)" />
              <i class="fa fa-send cor1" id="btnSend" (click)="enviarMgsUsuarioParaRobo(null, null)"></i>
          </div>
      </article>

  </section>
</main>
